import Vue from 'vue'
import Vuex from 'vuex'
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfigRaw from '@/../tailwind.config.js'

import authenticationModule from '../views/authentication/login/Login.module'
import verifyOtpModal from '../views/authentication/verifyOtpModal/VerifyOtpModal.module'
import maintenanceModule from '../views/maintenance/Maintenance.module'
import popupModule from '../components/popup/Popup.module'
import locateVMModule from '../views/locateVendingMachines/LocateVendingMachines.module'
import campaignModule from '../campaign/Campaign.module'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    screenWidth: 0,
    tailwindConfig: resolveConfig(tailwindConfigRaw),
    isPayLahTile: false,
    payLahTileData: {},
    isLoggedIn: false,
    products: [],
    quotas: [],
    mobileNumbers: {
      accountNumber: '',
      paymentNumber: '',
    },
    transactionHistory: [],
    purchasing: {},
    paymentMethods: [],
    isLoading: false,
    successfulPurchase: null,
    allowBypass: false,
    bypassSuccess: false,
  },
  getters: {
    breakpoints(state) {
      const obj = {}
      const entries = Object.entries(state.tailwindConfig.theme.screens)

      entries.forEach(([size, px]) => {
        if (typeof px === 'string') {
          obj[size] = Number(px.replace('px', ''))
        }
      })

      return obj
    },

    activeBreakpoint(state, getters) {
      const { sm, md, lg } = getters.breakpoints

      if (state.screenWidth <= sm) return 'sm'
      else if (sm < state.screenWidth && state.screenWidth <= md) return 'md'
      else if (md < state.screenWidth && state.screenWidth <= lg) return 'lg'
      // else if (lg < state.screenWidth && state.screenWidth <= xl) return 'xl'
      else return 'xl'
    },

    totalAmount(state) {
      if (Object.keys(state.purchasing).length > 0) {
        let total = 0
        Object.entries(state.purchasing).forEach(([sku, qty]) => {
          const price = state.products.find(product => product.sku === sku)
            .price
          total += price * qty
        })

        return total
      } else {
        return 0
      }
    },
  },
  mutations: {
    setScreenWidth(state, payload) {
      state.screenWidth = payload
    },
    setIsPayLahTile(state, payload) {
      state.isPayLahTile = payload
    },
    setPayLahTileData(state, payload) {
      state.payLahTileData = payload
    },
    setIsLoggedIn(state, payload) {
      state.isLoggedIn = payload
    },
    setProducts(state, payload) {
      state.products = payload
    },
    setQuotas(state, payload) {
      state.quotas = payload
    },
    setMobileNumbers(state, payload) {
      state.mobileNumbers = payload
    },
    setTransactionHistory(state, payload) {
      state.transactionHistory = payload
    },
    setPurchasing(state, payload) {
      const { sku, qty } = payload
      Vue.set(state.purchasing, sku, qty)
    },
    setPaymentMethods(state, payload) {
      state.paymentMethods = payload
    },
    setIsLoading(state, payload) {
      state.isLoading = payload
    },
    setSuccessfulPurchase(state, payload) {
      state.successfulPurchase = payload
    },
    resetAfterSuccessfulPurchase(state) {
      state.purchasing = {}
    },
    setFilteredPurchasing(state, payload) {
      state.purchasing = payload
    },
    setAllowBypass(state, boolean) {
      state.allowBypass = boolean
    },
    setBypassSuccess(state, boolean) {
      state.bypassSuccess = boolean
    },
  },
  actions: {
    updateProducts({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setProducts', payload)
        resolve()
      })
    },
    updateQuotas({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setQuotas', payload)
        resolve()
      })
    },
    updateIsPayLahTile({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setIsPayLahTile', payload)
        resolve()
      })
    },
    updatePayLahTileData({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setPayLahTileData', payload)
        resolve()
      })
    },
    updateIsLoggedIn({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setIsLoggedIn', payload)
        resolve()
      })
    },
    updateMobileNumbers({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setMobileNumbers', payload)
        resolve()
      })
    },
    updateTransactionHistory({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setTransactionHistory', payload)
        resolve()
      })
    },
    updatePurchasing({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setPurchasing', payload)
        resolve()
      })
    },
    updatePaymentMethods({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setPaymentMethods', payload)
        resolve()
      })
    },
    updateSuccessfulPurchase({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setSuccessfulPurchase', payload)
        resolve()
      })
    },
  },
  modules: {
    verification: authenticationModule,
    verifyOtpModal,
    maintenance: maintenanceModule,
    popupNotification: popupModule,
    locateVendingMachines: locateVMModule,
    campaign: campaignModule,
  },
})
